import { VyFormSection, VyIcon } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import { ProductSourceSelect } from '../selectors';
import { FieldGrid } from '../../modify-panel-shared/layout';

export function AddUsageMeterSection() {
  const { itemIndex: productIndex } = useChargeContext();

  return (
    <VyFormSection icon={<VyIcon icon="ChartModernSquare" width={20} height={20} />} title="Add usage meter">
      <FieldGrid>
        <ProductSourceSelect name={`fixedProducts.${productIndex}.variants.0.meterId`} label="Select meter" />
      </FieldGrid>
    </VyFormSection>
  );
}
